import { useEffect, useState } from "react";
import { parseJSON } from "../utils";

const useWorkoutPlan = ({
    account,
    programs
}) => {

    const [modPrograms, setModPrograms] = useState(null);
    const [workoutPlan, setWorkoutPlan] = useState(null);
    const onboardingDetail = account?.onboardingDetails?.[account?.onboardingDetails?.length - 1];

    useEffect(() => {
        if (account?.user?.id && modPrograms?.["1"]?.id) {
            if (account?.onboardingDetails?.length > 0) {
                const schedule = ArrangeWorkoutPlan(parseJSON(onboardingDetail?.schedule));
                setWorkoutPlan({
                    schedule: schedule,
                });
            }
        }
    }, [account?.user?.id, account?.onboardingDetails?.length, modPrograms?.["1"]?.id]);

    const ArrangeWorkoutPlan = (wp) => {
        let temp = {}, temp2 = {}, tempProgram = {}, counter = {}, tempPID = "";
        for (let x = 0; x < wp?.length; x++) {
            temp2 = {};
            for (let y = 0; y < wp[x]?.days?.length; y++) {
                tempPID = wp[x]?.days[y]?.recommendedPrograms?.[0]?.programID || wp[x]?.days[y]?.recommendedPrograms?.programID;
                counter = {
                    ...counter,
                    [tempPID]: counter[tempPID] ? (counter[tempPID] + 1) : 1,
                }
                tempProgram = modPrograms[tempPID] || programs.find((p) => p?.title == wp[x]?.days[y]?.recommendedPrograms?.[0]?.program);
                temp2 = {
                    ...temp2,
                    [wp[x]?.days[y]?.day]: {
                        program: tempProgram,
                        border: "4px solid " + tempProgram?.gradient?.split("-")?.[0],
                    }
                }
            }

            temp = {
                ...temp,
                [wp[x]?.weekNo]: {
                    ...temp2,
                }
            }
        }

        return temp;
    }


    useEffect(() => {
        let temp = {};
        for (let x = 0; x < programs?.length; x++) {
            temp = {
                ...temp,
                [programs[x]?.id]: programs[x],
            }
        }
        setModPrograms(temp);
    }, [programs?.length]);

    return {
        workoutPlan
    };
}

export default useWorkoutPlan;
